import React, { useEffect, useState } from "react";
import { BsClock } from "react-icons/bs";
import { PiSealWarningFill } from "react-icons/pi";
import { RESET_LOADER, SET_LOADER } from "../../constants/contexConstant";
import {
    CONSUMER__METRICS_SUMMARY,
    CONSUMER_POWER_GENERATION_SUMMARY,
} from "../../constants/routes";
import { useContextState } from "../../context/ContextProvider";
import { getCurrencyAmount } from "../../helpers/helpers";
import cn from "../../lib/cn";
import {
    bluePie,
    blueWriting,
    carbon,
    grayPie,
    location,
    solar,
    streamLine,
    writing,
} from "../../resources/js/icons";
import { check } from "../../resources/js/images";
import request from "../../services/request";
import Container from "../../shared/Container";
import Section from "../../shared/Section";
import H4 from "../../shared/typography/H4";
import P from "../../shared/typography/P";
import SwitchingTabs from "../../shared/ui/tab/SwitchingTabs";
import Tag from "../../shared/ui/tag/Tag";
import CostDetails from "./CostDetails";
import Graph from "./Graph";
import PannelAnimation from "./PannelAnimation";
import PlantOverview from "./PlantOverview";
import TableReport from "./tableReport";
const labels = [
    "Solar Plant Report",
    "Savings Report",
    "Solar Plant Performance Report",
];
const frequencyMap = {
    Day: "daily",
    "One Week": "weekly",
    "One Month": "monthly",
    "One Year": "yearly",
    Lifetime: "lifetime",
};

// Outside your component, e.g. at the top of the file or in a separate file

export const genData = (totalGeneration, totalSavings, graphData) => [
    {
        index: "PV Solar Power",
        type: "bar",
        data: [
            {
                title: "PV Solar Power",
                label: "Total Generation",
                value: `${totalGeneration} kWh`,
                color: "text-blue-150",
                graphData: graphData.pvSolarPower,
            },
        ],
    },
    {
        index: "savings",
        type: "bar",
        data: [
            {
                title: "Savings",
                label: "Total Savings",
                value: `${totalSavings}`,
                color: "text-blue-150",
                graphData: graphData.savings,
            },
        ],
    },
    // {
    //     index: "performance",
    //     type: "bar",
    //     data: [
    //         {
    //             title: "Average Generation",
    //             label: "Average Generation",
    //             value: `${avgGeneration} kWh`,
    //             color: "text-blue-150",
    //             graphData: graphData?.avg_power_generation,
    //         },
    //         {
    //             title: "My Plant Generation",
    //             label: "Our Plant Generation",
    //             value: `${plantGeneration} kWh`,
    //             color: "text-orange",
    //             graphData: graphData?.power_generation,
    //         },
    //     ],
    // },
];

export const solarPlantReports = (
    solarData,
    graphData,
    checkIcon,
    P,
    PiSealWarningFill,
    getCurrencyAmount
) => [
    {
        index: "generation",
        data: [
            {
                label: "Daily Generation",
                subLabel: "Last 30 Days",
                value:
                    solarData?.metrics?.generation?.avgDailyGeneration?.toFixed(
                        0
                    ) || "XXX",
                unit: "Units",
            },
            {
                label: "Total Generation",
                subLabel: "From Beginning",
                value:
                    solarData?.metrics?.generation?.totalGeneration?.toFixed(
                        0
                    ) || "XXX",
                unit: "Units",
            },
            {
                label: "Plant Performance",
                subLabel: "Last 30 Days",
                value:
                    solarData?.metrics?.generation?.plantPerformance || "Good",
                icon:
                    solarData?.metrics?.generation?.plantPerformance ===
                    "Poor" ? (
                        <P className="text-orange md:text-lg xl:text-lg">
                            <PiSealWarningFill />
                        </P>
                    ) : (
                        <img src={checkIcon} alt="good" className="w-2 h-2" />
                    ),
                unit: "",
            },
            {
                label: "Plant Performance",
                subLabel: "Last 30 Days",
                value: solarData?.metrics?.generation?.plantPerformaceMom ? (
                    solarData?.metrics?.generation?.plantPerformaceMom > 0 ? (
                        <P className="text-green-200">
                            +
                            {solarData?.metrics?.generation?.plantPerformaceMom.toFixed(
                                2
                            )}
                            %
                        </P>
                    ) : (
                        <P className="text-red">
                            -
                            {solarData?.metrics?.generation?.plantPerformaceMom.toFixed(
                                2
                            )}
                            %
                        </P>
                    )
                ) : (
                    "XX%"
                ),
                unit: "Units",
            },
        ],
    },
    {
        index: "savings",
        data: [
            {
                label: "Daily Savings",
                subLabel: "Last 30 Days",
                value: solarData?.metrics?.savings?.avgDailySavings
                    ? `₹ ${getCurrencyAmount(
                          solarData?.metrics?.savings?.avgDailySavings
                      )}`
                    : "XXX",
                unit: "@ 12 Per Unit",
            },
            {
                label: "Lifetime Savings",
                subLabel: "From Beginning",
                value: solarData?.metrics?.savings?.lifeTimeSavings
                    ? `₹ ${getCurrencyAmount(
                          solarData?.metrics?.savings?.lifeTimeSavings
                      )}`
                    : "XXXXXX",
                unit: "@ 12 Per Unit",
            },
            {
                label: "Payback Period",
                subLabel: "Days Left",
                value: solarData?.metrics?.savings?.paybackPeriod
                    ? solarData?.metrics?.savings?.paybackPeriod > 366
                        ? (
                              solarData?.metrics?.savings?.paybackPeriod / 365
                          ).toFixed(2)
                        : solarData?.metrics?.savings?.paybackPeriod
                    : "XX",
                unit: "Years",
            },
        ],
    },
    {
        index: "performance",
        data: [
            // {
            //     label: "Plant Performance",
            //     subLabel: "Last 30 Days",
            //     value: solarData?.metrics?.generation
            //         ?.plantPerformaceMom ? (
            //         solarData?.metrics?.generation?.plantPerformaceMom >
            //         0 ? (
            //             <P className="text-green-200">
            //                 +
            //                 {solarData?.metrics?.generation?.plantPerformaceMom?.toFixed(
            //                     2
            //                 )}
            //                 %
            //             </P>
            //         ) : (
            //             <P className="text-red">
            //                 -
            //                 {solarData?.metrics?.generation?.plantPerformaceMom?.toFixed(
            //                     2
            //                 )}
            //                 %
            //             </P>
            //         )
            //     ) : (
            //         "XX%"
            //     ),
            //     unit: "Units",
            // },
            // {
            //     label: "Cleaning Done",
            //     subLabel: "Last 30 Days",
            //     value: "2",
            //     unit: "Times",
            //     graphData: graphData.avg_power_generation,
            // },
            // {
            //     label: "Plant Inspection",
            //     subLabel: "Schedule Date",
            //     value: "15 Mar '25",
            //     unit: "",
            //     graphData: graphData.avg_power_generation,
            // },
        ],
    },
];
const ConsumerDashboard = () => {
    const [currentSlide, setCurrentSlide] = useState(0);
    const [label, setLabel] = useState(labels[currentSlide]);
    const handleTabClick = (index) => {
        setCurrentSlide(index);
        setLabel(labels[index]);
    };
    const [projectEnable, setProjectEnable] = useState(false);
    const { dispatch } = useContextState();
    const [selection, setSelection] = useState("One Week");
    const [currentView, setCurrentView] = useState(2);
    const [currentSummary, setCurrentSummary] = useState(1);
    const [graphData, setGraphData] = useState({
        pvSolarPower: [],
        power_generation: [],
        savings: [],
        avg_power_generation: [],
    });
    const [endDate, setEndDate] = useState(new Date());
    const [solarData, setSolarData] = useState({});
    const fetchSolarData = async () => {
        try {
            dispatch({ type: SET_LOADER });
            const endpoint = CONSUMER__METRICS_SUMMARY;
            const result = await request.authGet({ endpoint });
            setSolarData(result?.data);
            setProjectEnable(true);
            dispatch({ type: RESET_LOADER });
        } catch (error) {
            dispatch({ type: RESET_LOADER });
        }
    };
    const fetchData = async () => {
        if (!endDate) return;

        const selectedFrequency = frequencyMap[selection];
        const endDateEpoch = parseInt(new Date(endDate).getTime() / 1000);
        try {
            dispatch({ type: SET_LOADER });
            const endpoint = `${CONSUMER_POWER_GENERATION_SUMMARY}&date=${endDateEpoch}&frequency=${selectedFrequency}`;
            const result = await request.authGet({ endpoint });

            if (result.status === "SUCCESS" && result?.data?.metrics) {
                const { powerGenerationDTO, averagePowerGenerationDto } =
                    result.data.metrics;

                const transformedData = {
                    pvSolarPower: powerGenerationDTO?.map((item) => ({
                        timestamp: item.timestamp,
                        value: item.pvSolarPower,
                    })),
                    power_generation: powerGenerationDTO?.map((item) => ({
                        timestamp: item.timestamp,
                        value: item.generationPerKw,
                    })),

                    avg_power_generation: averagePowerGenerationDto?.map(
                        (item) => ({
                            timestamp: item.timestamp,
                            value: item.averagePowerGeneration,
                        })
                    ),
                    savings: powerGenerationDTO?.map((item) => ({
                        timestamp: item.timestamp,
                        value: item.saving,
                    })),
                };

                setGraphData(transformedData);
                setProjectEnable(true);
                dispatch({ type: RESET_LOADER });
            }
        } catch (error) {
            dispatch({ type: RESET_LOADER });
        }
    };

    const handleDateChange = (end) => {
        const updatedDate = new Date(end);

        const currentDate = new Date();

        updatedDate.setHours(currentDate.getHours());
        updatedDate.setMinutes(currentDate.getMinutes());
        updatedDate.setSeconds(currentDate.getSeconds());
        updatedDate.setMilliseconds(currentDate.getMilliseconds());

        setEndDate(updatedDate);
    };
    useEffect(() => {
        fetchSolarData();
    }, []);
    useEffect(() => {
        if (endDate) {
            fetchData();
        }
    }, [endDate, selection]);
    const totalGeneration = (
        (graphData.pvSolarPower.reduce(
            (sum, item) => sum + parseFloat(item.value || 0),
            0
        ) *
            5) /
        (60 * 1000)
    ).toFixed(1);

    // const avgGeneration = (
    //     (graphData?.avg_power_generation?.reduce(
    //         (sum, item) => sum + parseFloat(item.value || 0),
    //         0
    //     ) *
    //         5) /
    //     (60 * 1000)
    // ).toFixed(2);

    // const plantGeneration = (
    //     (graphData?.power_generation?.reduce(
    //         (sum, item) => sum + parseFloat(item.value || 0),
    //         0
    //     ) *
    //         5) /
    //     (60 * 1000)
    // ).toFixed(2);

    const totalSavings = graphData.savings
        .reduce((sum, item) => sum + parseFloat(item.value || 0), 0)
        .toFixed(0)

        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    const updateData = (v) => {
        setSelection(v);
    };
    const generatedData = genData(totalGeneration, totalSavings, graphData);
    const checkIcon =
        solarData?.metrics?.generation?.plantPerformance === "Poor" ? (
            <P className="text-orange md:text-lg xl:text-lg">
                <PiSealWarningFill />
            </P>
        ) : (
            <img src={check} alt="good" className="w-2 h-2" />
        );
    const solarReports = solarPlantReports(
        solarData,
        graphData,
        checkIcon,
        P,
        PiSealWarningFill,
        getCurrencyAmount
    );
    return (
        <Section className=" pt-8.8 lg:pt-10.4 md:py-[6rem] bg-blue-700 md:bg-white mb-0 lg:mb-0 xl:mb-0 2xl:mb-0 min-h-svh md:min-h-screen ">
            <Container>
                <div className="md:hidden ">
                    <div className="flex justify-between items-center">
                        <div role="button" onClick={() => setCurrentSummary(1)}>
                            <P
                                className={cn("text-gray-370", {
                                    "text-white border-b-2 border-b-blue pb-1":
                                        currentSummary === 1,
                                })}
                            >
                                Summary
                            </P>
                        </div>
                        <div role="button" onClick={() => setCurrentSummary(2)}>
                            <P
                                className={cn("text-gray-370", {
                                    "text-white border-b-2 border-b-blue pb-1":
                                        currentSummary === 2,
                                })}
                            >
                                Configuration
                            </P>
                        </div>
                    </div>
                    <div className="flex justify-between items-center mt-3">
                        <H4 className="text-white">Godrej Horizon</H4>
                        <Tag
                            text={"Apartment"}
                            className={"bg-green-100 rounded-3xl p-0.5"}
                            textClass={"text-green !text-xs"}
                        />
                    </div>
                    <P className="text-gray-370 flex gap-1 items-center mb-3">
                        <BsClock />
                        15 July 2023
                    </P>
                    {currentSummary === 1 ? (
                        <div>
                            <div className="bg-blue-550 rounded-[2rem]  my-3 p-0.5">
                                <div className="bg-blue-700 m-1 rounded-3xl flex gap-1 justify-between p-2 item-center">
                                    <div className="flex flex-col gap-0.5">
                                        {solarData?.metrics?.purchase ? (
                                            <>
                                                <P className="text-gray-370 text-xs">
                                                    Generation
                                                </P>
                                                <H4 className="text-white text-sm text-nowrap">
                                                    {projectEnable
                                                        ? ` ${solarData?.metrics?.generation?.avgDailyGeneration?.toFixed(
                                                              0
                                                          )} KWh / Day`
                                                        : "XXX"}
                                                </H4>
                                            </>
                                        ) : (
                                            <>
                                                <P className="text-gray-370 text-xs text-nowrap">
                                                    Monthly Lease Payment
                                                </P>
                                                <H4 className="text-white text-sm text-nowrap">
                                                    {projectEnable
                                                        ? `₹ ${solarData?.metrics?.lease?.monthlyLeasePayment?.toFixed(
                                                              0
                                                          )}`
                                                        : "XXX"}
                                                </H4>
                                            </>
                                        )}
                                    </div>

                                    <div className="flex flex-col gap-0.5 ml-4">
                                        {solarData?.metrics?.purchase ? (
                                            <>
                                                <P className="text-gray-370 text-xs text-nowrap">
                                                    Payback Period
                                                </P>
                                                <H4 className="text-white text-sm text-nowrap">
                                                    {projectEnable
                                                        ? `${(
                                                              solarData?.metrics
                                                                  ?.savings
                                                                  ?.paybackPeriod /
                                                              12
                                                          )?.toFixed(0)} Years`
                                                        : "XXX"}
                                                </H4>
                                            </>
                                        ) : (
                                            <>
                                                <P className="text-gray-370 text-xs text-nowrap">
                                                    Lifetime Savings
                                                </P>
                                                <H4 className="text-white text-sm text-nowrap">
                                                    {projectEnable
                                                        ? `₹ ${getCurrencyAmount(
                                                              solarData?.metrics
                                                                  ?.savings
                                                                  ?.lifeTimeSavings
                                                          )}`
                                                        : "XXX"}
                                                </H4>
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className="flex flex-col gap-1">
                                <CostDetails
                                    type={
                                        solarData?.metrics?.purchase
                                            ? "purchase"
                                            : "lease"
                                    }
                                    cost={`₹ ${solarData?.metrics?.purchase?.solarPlantCost?.toLocaleString()}`}
                                    savingsTillDate={`₹ ${solarData?.metrics?.savings?.lifeTimeSavings
                                        ?.toFixed(0)
                                        ?.toLocaleString()}`}
                                    monthlySavings={`₹ ${(
                                        Number(
                                            solarData?.metrics?.lease
                                                ?.billWithoutSolar
                                        ) -
                                        Number(
                                            solarData?.metrics?.lease
                                                ?.monthlyLeasePayment
                                        )
                                    )?.toLocaleString()}`}
                                    billWithoutSolar={`₹ ${solarData?.metrics?.lease?.billWithoutSolar?.toLocaleString()}`}
                                    savingPercentage={
                                        ((Number(
                                            solarData?.metrics?.lease
                                                ?.billWithoutSolar
                                        ) -
                                            Number(
                                                solarData?.metrics?.lease
                                                    ?.monthlyLeasePayment
                                            )) *
                                            100) /
                                        Number(
                                            solarData?.metrics?.lease
                                                ?.billWithoutSolar
                                        )
                                    }
                                    projectEnable={projectEnable}
                                />
                            </div>
                        </div>
                    ) : (
                        <div className="bg-blue-550 rounded-2xl p-1.5">
                            <div className="bg-blue-700 p-2 rounded-3xl  flex justify-between item-center mb-4">
                                <div className="flex flex-col gap-0.5">
                                    <H4 className="text-white text-sm text-nowrap">
                                        Azad Nagar, Wadalaa
                                    </H4>
                                    <P className="text-gray-370 flex items-center gap-1 text-xs text-nowrap">
                                        <img src={location} alt="location" />{" "}
                                        Pune, Maharashtra
                                    </P>
                                </div>
                                <div className="flex flex-col gap-0.5">
                                    <H4 className="text-white text-sm text-nowrap">
                                        {projectEnable ? " 6 KWp" : "XXX"}
                                    </H4>
                                    <P className="text-gray-370 text-xs text-nowrap">
                                        Plant Size
                                    </P>
                                </div>
                            </div>
                            <PannelAnimation projectEnable={projectEnable} />
                        </div>
                    )}
                </div>

                <div>
                    <div className=" rounded-xl hidden md:flex gap-2  flex-wrap lg:flex-nowrap justify-between items-center">
                        <div className=" p-2 w-full lg:w-1/2 rounded-xl ">
                            <div className="flex w-full flex-col justify-between items-center gap-1">
                                <div className="mb-2 w-full">
                                    <div className="flex justify-between items-center gap-2">
                                        <H4>Godrej Horizon</H4>
                                        <Tag
                                            text={"Residential Society"}
                                            className={
                                                "bg-green-100 rounded-3xl p-0.5"
                                            }
                                            textClass={"text-green !text-xs"}
                                        />
                                    </div>
                                    <P className="text-secondary mt-1">
                                        Azad Nagar, Wadala, Mumbai, Maharashtra
                                        400031
                                    </P>
                                </div>
                                <div className="flex flex-col  justify-between gap-1      border-t-2 border-gray-50  w-full py-2 ">
                                    <CostDetails
                                        type={
                                            solarData?.metrics?.purchase
                                                ? "purchase"
                                                : "lease"
                                        }
                                        cost={`₹ ${solarData?.metrics?.purchase?.solarPlantCost?.toLocaleString()}`}
                                        savingsTillDate={`₹ ${solarData?.metrics?.savings?.lifeTimeSavings?.toLocaleString()}`}
                                        monthlySavings={`₹ ${(
                                            Number(
                                                solarData?.metrics?.lease
                                                    ?.billWithoutSolar
                                            ) -
                                            Number(
                                                solarData?.metrics?.lease
                                                    ?.monthlyLeasePayment
                                            )
                                        )?.toLocaleString()}`}
                                        billWithoutSolar={`₹ ${solarData?.metrics?.lease?.billWithoutSolar?.toLocaleString()}`}
                                        savingPercentage={
                                            ((Number(
                                                solarData?.metrics?.lease
                                                    ?.billWithoutSolar
                                            ) -
                                                Number(
                                                    solarData?.metrics?.lease
                                                        ?.monthlyLeasePayment
                                                )) *
                                                100) /
                                            Number(
                                                solarData?.metrics?.lease
                                                    ?.billWithoutSolar
                                            )
                                        }
                                        projectEnable={projectEnable}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="w-full  lg:w-[40%] p-0.8">
                            <PannelAnimation projectEnable={projectEnable} />
                        </div>
                    </div>
                    <PlantOverview
                        type={
                            solarData?.metrics?.purchase ? "purchase" : "lease"
                        }
                        projectEnable={projectEnable}
                        solarPlantSize={
                            solarData?.metrics?.purchase
                                ? `${solarData?.metrics?.purchase?.plantSize} KWp`
                                : `${solarData?.metrics?.lease?.plantSize} KWp`
                        }
                        avgUnitGeneration={` ${solarData?.metrics?.generation?.avgDailyGeneration?.toFixed(
                            0
                        )} KWh / Day`}
                        paybackPeriod={`${(
                            solarData?.metrics?.savings?.paybackPeriod / 12
                        )?.toFixed(2)} Years`}
                        monthlyLease={`₹${solarData?.metrics?.lease?.monthlyLeasePayment?.toLocaleString()} / mo`}
                        lifetimeSavings={`₹ ${getCurrencyAmount(
                            solarData?.metrics?.savings?.lifeTimeSavings
                        )}`}
                        icons={{ solar, carbon, streamLine }}
                    />
                </div>
            </Container>
            <Container className="pt-3 max-w-screen-xl px-0 lg:px-1 2xl:container">
                <div className="flex w-full justify-center min-h-[50rem] mb-5 lg:hidden mt-4 bg-white p-2  rounded-t-[5rem]">
                    <div className="flex w-full flex-col items-center lg:hidden ">
                        <div className="flex lg:hidden justify-center items-center ">
                            <SwitchingTabs
                                unseclectedColor="bg-white text-secondary"
                                border={
                                    "border border-blue-50 rounded-[3rem] lg:rounded-xl bg-white"
                                }
                                options={["Generation", "Savings"]}
                                currentTab={currentSlide}
                                onTabClick={handleTabClick}
                            />
                        </div>
                        <div className="flex lg:hidden w-full justify-between my-3 items-center">
                            <P>{label}</P>
                            <div className="flex gap-2 items-center">
                                <div
                                    role="button"
                                    onClick={() => setCurrentView(1)}
                                >
                                    <img
                                        src={
                                            currentView === 1
                                                ? blueWriting
                                                : writing
                                        }
                                        alt="data"
                                    />
                                </div>
                                <div
                                    role="button"
                                    onClick={() => setCurrentView(2)}
                                >
                                    <img
                                        src={
                                            currentView === 1
                                                ? grayPie
                                                : bluePie
                                        }
                                        className={cn({
                                            "w-2 h-2": currentView === 2,
                                        })}
                                        alt="graph"
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="w-full mb-5 lg:hidden">
                            {currentView === 1 ? (
                                <TableReport
                                    label={label}
                                    projectEnable={projectEnable}
                                    data={solarReports[currentSlide]?.data}
                                />
                            ) : (
                                <Graph
                                    endDate={endDate}
                                    projectEnable={projectEnable}
                                    updateData={updateData}
                                    selection={selection}
                                    onDateChange={handleDateChange}
                                    type={generatedData[currentSlide].type}
                                    genData={generatedData[currentSlide].data}
                                    data={generatedData[currentSlide].data}
                                />
                            )}
                        </div>
                    </div>
                </div>
                <div className=" w-full  hidden   lg:block mt-4 p-2 bg-transparent ">
                    {generatedData.map((genItem, index) => (
                        <div
                            key={index}
                            className="flex justify-between gap-3 items-stretch w-full mb-4"
                        >
                            <div className="w-full">
                                <Graph
                                    endDate={endDate}
                                    updateData={updateData}
                                    selection={selection}
                                    onDateChange={handleDateChange}
                                    type={genItem.type}
                                    genData={genItem.data}
                                    data={genItem.data}
                                    projectEnable={projectEnable}
                                />
                            </div>
                            <div className="w-[70%]">
                                <TableReport
                                    projectEnable={projectEnable}
                                    label={labels[index]}
                                    data={solarReports[index]?.data}
                                />
                            </div>
                        </div>
                    ))}
                </div>
            </Container>
        </Section>
    );
};

export default ConsumerDashboard;
